import { render, staticRenderFns } from "./QRenewedSelect.vue?vue&type=template&id=54ed4cd9&scoped=true&"
import script from "./QRenewedSelect.vue?vue&type=script&lang=js&"
export * from "./QRenewedSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ed4cd9",
  null
  
)

export default component.exports